// src/pages/Courses.jsx
import React from 'react';
import CourseHero from '../components/courses/CourseHero';
import CoursesSection from '../components/courses/CoursesSection';
import Testimonials from '../components/home/Testimonials'; // Assuming you have this

const CoursesPage = () => {
  return (
    <div>
      <CourseHero />
      <CoursesSection />
      <Testimonials /> {/* Include other sections as needed */}
    </div>
  );
};

export default CoursesPage;